import React from "react";

/**
 * SummaryStatCard — one of the 5 headline tiles at the top of the
 * collection-first dashboard. Every metric is authoritative
 * (backend-computed) so the frontend never derives numbers.
 *
 * The card is intentionally quiet visually — bold number, tiny label,
 * subtle icon. Ordering + count comes from `/dashboard-summary`.
 */
export default function SummaryStatCard({ label, value, hint, Icon, tone = "default", testid }) {
  const toneCls = {
    default: "bg-white",
    accent:  "bg-[var(--panini-yellow-soft)]",
    good:    "bg-emerald-50",
    red:     "bg-[var(--panini-red-soft)]",
  }[tone] || "bg-white";
  return (
    <div
      className={`rounded-2xl border-2 border-[var(--ink)] ${toneCls} p-5 md:p-6 shadow-[4px_4px_0_var(--ink)] min-h-[140px] md:min-h-[152px] flex flex-col justify-between`}
      data-testid={testid}
      role="group"
      aria-label={`${label}: ${value}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div
            className="text-[10px] uppercase tracking-[0.12em] text-[var(--smoke)] font-bold leading-tight"
            style={{ wordBreak: "normal", overflowWrap: "break-word" }}
          >
            {label}
          </div>
        </div>
        {Icon && (
          <div className="shrink-0 w-9 h-9 rounded-lg bg-white border-2 border-[var(--ink)] grid place-items-center">
            <Icon size={16} aria-hidden />
          </div>
        )}
      </div>
      <div
        className="font-display text-4xl md:text-5xl leading-none tabular-nums mt-2"
        data-testid={testid ? `${testid}-value` : undefined}
      >
        {value}
      </div>
      {hint && (
        <div className="text-[11px] text-[var(--smoke)] mt-2 leading-snug">{hint}</div>
      )}
    </div>
  );
}
